import type { SxProps, Theme } from '@mui/material';

/** Brand gradient constants */
export const gradients = {
  /** Primary teal-to-green gradient (used on buttons, badges) */
  primary: 'linear-gradient(90deg, #1ebec8 -7.19%, #86c65a 105.94%)',
  /** Alt gradient for public-facing elements */
  alt: 'linear-gradient(56deg, #18bad4 0%, #31b680 51.56%, #80c242 100%)',
  /** Golden gradient for premium elements */
  golden: 'linear-gradient(to right, #f09819 0%, #edde5d 51%, #f09819 100%)',
  /** Semi-transparent version for scrollbar */
  primaryAlpha: 'linear-gradient(90deg, #1ebec86e -7.19%, #86c65a85 105.94%)',
  /** Orange solid for accent buttons */
  orange: '#f79153',
} as const;

/** sx helper for gradient text fill */
export const gradientTextSx: SxProps<Theme> = {
  background: gradients.primary,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  color: 'transparent',
};

/** sx helper for gradient border (using background-clip trick) */
export const gradientBorderSx = (borderWidth = 1): SxProps<Theme> => ({
  position: 'relative',
  border: `${borderWidth}px solid transparent`,
  backgroundClip: 'padding-box',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    margin: `-${borderWidth}px`,
    borderRadius: 'inherit',
    background: gradients.primary,
    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
    padding: `${borderWidth}px`,
    pointerEvents: 'none',
  },
});
